import { NavLink, withRouter } from 'react-router-dom'
import _ from 'lodash'
import { connect } from 'react-redux'
import confUtil from '../../../../lib/confUtil'
import { ANCHOR_LINK_MAP } from '../constants'
import styles from './Sidebar.css'

// only show itemPage
const SideBarItems = _.map(
  _.filter(ANCHOR_LINK_MAP, anchor => anchor.itemPage),
  anchor => {
    const { link, linkTitle } = anchor
    return {
      label: linkTitle,
      link: `/seller/items/${link}`
    }
  }
)

const Sidebar = (props) => {
  const { location, envConf } = props
  const isActive = (match, location = {}) => {
    const currentPath = location.pathname
    return currentPath.includes(match.link)
  }

  return (
    <div className={styles.sidebar}>
      {SideBarItems.map((item, index) => {
        const { label, link } = item
        return (
          <NavLink
            key={index}
            activeClassName='active'
            className={styles.sidebarItem}
            isActive={() => isActive(item, location)}
            to={link}
          >
            {label}
          </NavLink>
        )
      })}
      <a
        key='sellerDashboard'
        className={styles.sidebarItem}
        href='../dashboard'
      >
        回商店經營儀表板
      </a>
      <a
        key='sellerAdmin'
        className={styles.sidebarItem}
        href={confUtil.getAbsUrl(envConf)('sellerAdmin')}
      >
        回店家後台
      </a>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  const envConf = _.get(state, 'page.envConf', {})
  return {
    envConf
  }
}

export default connect(
  mapStateToProps
)(withRouter(Sidebar))
